import React from 'react';
import LastUpdated from '../components/LastUpdated';
import PageHeader from '../components/PageHeader';
import ProjectUIUtils from '../projects/ProjectUIUtils';

import CollapsibleNote from "../base/CollapsibleNote";
import ApiUtils from '../util/ApiUtils';
import LogoUtils from '../util/LogoUtils';
import NetworkInline from './NetworkInline';
import NetworkUtils from './NetworkUtils';

class Network extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      network: {},
      notification: {},
      width: window.innerWidth,
      size: 10,
      responsive: true,
      isLoading: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.getLogo = this.getLogo.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    var coin = "";
    if (this.props.match && this.props.match.params.coin) {
      coin = this.props.match.params.coin;
    }

    let url = "listData?type=networkDecentralizationDetails&coin=" + coin;
    // console.log("url:", url);

    const allData = await ApiUtils.get(url);
    // console.log("allData is:", allData);

    if (allData) {
      let data = allData["data"];
      this.setState({"network": data, "notification": allData["notification"], 
        "lastUpdated": allData["lastUpdated"], isLoading: false});
    }
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading</div>;
    }

    return (
      <div>
        <p/>
        <PageHeader logo={this.getLogo} title={this.state.network.name + " Details"} 
          thisObj={this} notification={this.state.notification} delegateLink={false}/>
        <div>{this.state.network.description}</div>
        <br/>
        <div>{ProjectUIUtils.formatMedia(null, this.state.network)}</div>
        <NetworkInline network={this.state.network} />
        <CollapsibleNote getScreenGuide={NetworkUtils.getDisclaimer} label="Disclaimer / Notes" />
        <p/>
        <CollapsibleNote getScreenGuide={NetworkUtils.getScreenGuide} />
        <LastUpdated thisObj={this} recentBlock={false} />
      </div>
    );
  }

  getLogo() {
    return LogoUtils.projectLogo(this.state.network.logo, this.state.network);
  }

}

export default Network;



// WEBPACK FOOTER //
// ./src/network/Network.js